import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { graphql } from 'gatsby'
import { FormattedMessage, useIntl } from "gatsby-plugin-intl"
import Layout from '../components/Layout'
import BreadCrumb from '../components/Breadcrumb'
import { get_title } from '../misc/category_master';
import { Link } from '../components/Link';

const Article = ({pageContext, data}) => {
  const {category_articles} = data;
  const {slug, category1, category2, language} = pageContext;
  const paths = [category1, category2];

  const intl = useIntl();
  const category1_title = intl.formatMessage({id: get_title(slug.split('/').slice(3, 4))});
  const category2_title = intl.formatMessage({id: get_title(paths)});

  const title = `${category1_title} > ${category2_title} | ${intl.formatMessage({id: 'SocialDogヘルプ'})}`;
  const description = intl.formatMessage({
    id: 'SocialDogのヘルプ。ツイート管理、フォロワー、キーワードモニター、メンション、フォロー、ミュートなどの機能や使い方、有料プラン、Twitterアカウント連携の管理についてなどの記事があります。'
  });

  return (
    <Layout language={language}>
      <BreadCrumb paths={paths} language={language} />
      <div id="main_container">
        <Helmet>
          <title>{title}</title>
          <meta property="og:title" content={title} />
          <meta property="twitter:title" content={title} />
          <meta
            content={description}
            name="description"/>
          <meta property="og:description" content={description} />
          <meta property="twitter:description" content={description} />
        </Helmet>
        <section id="main_wide">
          <h2><FormattedMessage id={get_title(paths)} /></h2>
          <ul className='category2'>
            {category_articles.edges.map(edge => (
              <li key={edge.node.fields.slug}>
                <Link to={`${edge.node.fields.slug}`} key={edge.node.fields.slug}>
                  {edge.node.frontmatter.title}
                </Link>
              </li>
            ))}
          </ul>
        </section>
      </div>
    </Layout>
  )
};

Article.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.object,
  }),
};

export default Article

export const query = graphql`
  query ($regex: String, $language: String) {
    category_articles: allMarkdownRemark(filter: {
      fields: {slug: {regex: $regex}, lang: {eq: $language}},
    },
      sort: {order: DESC, fields: frontmatter___order_priority}
    ) {
      edges {
        node {
          frontmatter {
            title
          }
          fields {
            slug
          }
        }
      }
    }
  }
`;
